"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _hadate = require("../../../helpers/hadate");

var minimumStayMonthsBuilder = function minimumStayMonthsBuilder(params, context) {
  if (params.startDate && params.endDate) {
    return "(minimumStayMonths<=" + (0, _hadate.getMonthsBetween)(params.startDate, params.endDate) + ")";
  }

  return '';
};

var _default = minimumStayMonthsBuilder;
exports["default"] = _default;